import React from 'react'

import { Icon, ChevronRight, Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { shape, string } from 'prop-types'

import List from 'Pods/Shared/Icons/List'

const ChevronRightIcon = (
  <Icon
    color="light"
    size="default"
    svgComponent={ChevronRight}
    className="category-mega-menu__footer-trail"
  />
)
const ListIcon = <List className="category-mega-menu__footer-icon" width="20" height="20" />

// Footer action row: three outlined shortcuts (New / Trending / Top Selling) and the
// filled primary "All models" CTA. Rendered as anchors (href), so no form-submit
// concern. Horizontal at md+, stacked full-width on mobile (CSS).
function MegaFooter({ baseUrl, translations }) {
  const actions = [
    { key: 'new', label: translations.new, href: `${baseUrl}/new` },
    { key: 'trending', label: translations.trending, href: `${baseUrl}/trending` },
    { key: 'topSelling', label: translations.topSelling, href: `${baseUrl}/top-selling` },
  ]

  return (
    <div className="category-mega-menu__footer">
      {actions.map((action) => (
        <Button
          key={action.key}
          href={action.href}
          type="secondary-with-primary-border"
          customClass="category-mega-menu__footer-action"
          noWrap
        >
          {action.label}
        </Button>
      ))}
      <Button
        href={`${baseUrl}?page=1`}
        type="primary"
        customClass="category-mega-menu__footer-action category-mega-menu__footer-action--primary"
        icon={ListIcon}
        trailIcon={ChevronRightIcon}
        variant="with-icon"
        noWrap
      >
        {translations.allModels}
      </Button>
    </div>
  )
}

MegaFooter.propTypes = {
  baseUrl: string.isRequired,
  translations: shape({
    new: string.isRequired,
    trending: string.isRequired,
    topSelling: string.isRequired,
    allModels: string.isRequired,
  }).isRequired,
}

export default MegaFooter
